(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/components/games.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/components/games.js');

'use strict';

const {
  useSelector
} = ReactRedux;
const {
  GameCard,
  TicketCard,
  PackageClosedInfo
} = svs.gamePackage.components;
const Games = () => {
  const gamesDisplayOrder = useSelector(state => state.numbergames.gamesDisplayOrder);
  const tickets = useSelector(state => state.tickets.games);
  const packageIsClosed = useSelector(state => state.gamePackage.packageIsClosed);
  const isExpandable = !svs.core.config.data.svsconfig.isSelfService;
  return React.createElement(React.Fragment, null, packageIsClosed && React.createElement(PackageClosedInfo, null), React.createElement("div", {
    className: "gp-games-container"
  }, tickets.map((_ref, index) => {
    let {
      price,
      product,
      skin
    } = _ref;
    return React.createElement(TicketCard, {
      key: index,
      price: price,
      product: product,
      skin: skin,
      isExpandable: isExpandable,
      packageIsClosed: packageIsClosed
    });
  }), gamesDisplayOrder.map(_ref2 => {
    let {
      uniqueId
    } = _ref2;
    return React.createElement(GameCard, {
      key: uniqueId,
      uniqueId: uniqueId,
      isExpandable: isExpandable,
      packageIsClosed: packageIsClosed
    });
  })));
};
svs.gamePackage.components.Games = Games;

 })(window);